export const RupeeSymbol = () => {
  // using div as of now aditya will look forward to a solution using inline tag here
  return <div className="rupee-symbol">&#x20B9;</div>;
};



// WEBPACK FOOTER //
// ./components/rupeeSymbol/index.js